import React from 'react'
import './App.css'
import { NexorAvailable } from 'components/NexorAvailable';

// La plataforma fue dada de baja. Ya no se monta la aplicación (rutas, vistas,
// providers de datos ni autenticación): el único componente que se carga es el
// modal que informa la baja y redirige a Nexor.
function App() {
  return <NexorAvailable />;
}

export default App;
